import Svg, { Circle, G, Text, TSpan } from 'react-native-svg'

const empower = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 80 80"
    >
      <g data-name="Group 4106" transform="translate(-174 -1896)">
        <circle
          cx="40"
          cy="40"
          r="40"
          fill="#24397a"
          data-name="Ellipse 62"
          transform="translate(174 1896)"
        ></circle>
        <path
          fill="#fff"
          d="M15.031-14H22a1.885 1.885 0 011.819 1.294 1.909 1.909 0 01-.5 2.213l-16 14a2 2 0 01-3.157-2.295L8.969-10H1.944a1.988 1.988 0 01-1.816-1.294 2.006 2.006 0 01.555-2.212l16-14a2 2 0 012.494-.113 2 2 0 01.662 2.406L15.031-14z"
          data-name="Path 2250"
          transform="translate(202 1948)"
        ></path>
      </g>
    </svg>
  )
}

export default empower
